import React from 'react';
import styles from '../../assets/css/vendors/steps_vendor.module.css';
import PropTypes from 'prop-types';

const Steps = ({ step, steps, title, stylesTitle }) => {
    return (
        <div className={styles.login__header}>
            <div className={styles.login__header_content}>
                <div className={styles.items}>
                    {steps.map((value, index) => (
                        <React.Fragment key={index}>
                            <div className={styles.item}>
                                <div
                                    className={`${styles.circle} ${
                                        step === index && value.background
                                    }`}>
                                    <span>{index + 1}</span>
                                </div>
                                <p className={value.selectedText}>
                                    {value.name}
                                </p>
                            </div>
                            {index + 1 < steps.length && (
                                <hr className={styles.separator} />
                            )}
                        </React.Fragment>
                    ))}
                </div>
                <div className={`${styles.title} ${styles.marginTop}`}>
                    <p className={stylesTitle}>{title}</p>
                </div>
            </div>
        </div>
    );
};
Steps.propTypes = {
    step: PropTypes.number,
    steps: PropTypes.array,
    title: PropTypes.string,
    stylesTitle: PropTypes.string
};
export default Steps;
